export const appQueryKeys = {
  weeklyMomentsRoot: () => ["weekly-moments"] as const,
  weeklyMoments: (
    leaderId?: string,
    weekKey?: string,
    weekOffset?: number,
    timezone?: string,
    zoomConnected?: boolean,
  ) => ["weekly-moments", leaderId, weekKey, weekOffset, timezone, zoomConnected] as const,
  todayScheduleRoot: () => ["today-schedule"] as const,
  todaySchedule: (
    leaderId?: string,
    weekKey?: string,
    timezone?: string,
    zoomConnected?: boolean,
  ) => ["today-schedule", leaderId, weekKey, timezone, zoomConnected] as const,
  upcomingMeetingsRoot: () => ["upcoming-meetings"] as const,
  dashboardDataRoot: () => ["dashboard-data"] as const,
  dashboardData: (leaderId?: string) => ["dashboard-data", leaderId] as const,
  transcriptUploadsThisWeekRoot: () => ["transcript-uploads-this-week"] as const,
  livingConstellationStateRoot: () => ["living-constellation-state"] as const,
  livingConstellationState: (leaderId?: string) => ["living-constellation-state", leaderId] as const,
  leaderInsightsRoot: () => ["leader-insights"] as const,
  leaderInsights: (leaderId?: string) => ["leader-insights", leaderId] as const,
  transcriptAnalysesRoot: () => ["transcript-analyses"] as const,
  transcriptAnalyses: (leaderId?: string) => ["transcript-analyses", leaderId] as const,
  unviewedInsightsCountRoot: () => ["unviewed-insights-count"] as const,
  unviewedInsightsCount: (leaderId?: string) => ["unviewed-insights-count", leaderId] as const,
  leaderTranscriptTrendsRoot: () => ["leader-transcript-trends"] as const,
  leaderTranscriptTrends: (leaderId?: string) => ["leader-transcript-trends", leaderId] as const,
  postMeetingListRoot: () => ["post-meeting-list"] as const,
  postMeetingList: (leaderId?: string) => ["post-meeting-list", leaderId] as const,
  todayAnalyzedTranscriptCountRoot: () => ["today-analyzed-transcript-count"] as const,
  todayAnalyzedTranscriptCount: (leaderId?: string) => ["today-analyzed-transcript-count", leaderId] as const,
  leaderExperienceRoot: () => ["leader-experience"] as const,
  leaderExperience: (leaderId?: string) => ["leader-experience", leaderId] as const,
  coachNewEvidenceRoot: () => ["coach-new-evidence"] as const,
  coachNewEvidence: (coachId?: string) => ["coach-new-evidence", coachId] as const,
  coachProfileRoot: () => ["coach-profile"] as const,
  coachProfile: (coachId?: string) => ["coach-profile", coachId] as const,
  coachArtifactsRoot: () => ["coach-artifacts"] as const,
  coachArtifacts: (coachId?: string) => ["coach-artifacts", coachId] as const,
  coachArtifactExtractionsRoot: () => ["coach-artifact-extractions"] as const,
  coachArtifactExtractions: (coachId?: string) => ["coach-artifact-extractions", coachId] as const,
  coachTwinProfilesRoot: () => ["coach-twin-profiles"] as const,
  coachTwinProfiles: (coachId?: string) => ["coach-twin-profiles", coachId] as const,
  coachPortfolioSnapshotRoot: () => ["coach-portfolio-snapshot"] as const,
  coachPortfolioSnapshot: (coachId?: string, isDemoMode?: boolean) =>
    ["coach-portfolio-snapshot", coachId, isDemoMode] as const,
  coachProactiveBriefsRoot: () => ["coach-proactive-briefs"] as const,
  coachProactiveBriefs: (coachId?: string, isDemoMode?: boolean) =>
    ["coach-proactive-briefs", coachId, isDemoMode] as const,
  coachOverviewDiagnosticsRoot: () => ["coach-overview-diagnostics"] as const,
  coachOverviewDiagnostics: (coachId?: string, isDemoMode?: boolean) =>
    ["coach-overview-diagnostics", coachId, isDemoMode] as const,
  coachDataFreshnessRoot: () => ["coach-data-freshness"] as const,
  coachDataFreshness: (coachId?: string, isDemoMode?: boolean) =>
    ["coach-data-freshness", coachId, isDemoMode] as const,
  coachMomentumIndicatorsRoot: () => ["coach-momentum-indicators"] as const,
  coachMomentumIndicators: (coachId?: string, isDemoMode?: boolean) =>
    ["coach-momentum-indicators", coachId, isDemoMode] as const,
  coachTranscriptTrendsRoot: () => ["coach-transcript-trends"] as const,
  coachTranscriptTrends: (coachId?: string, isDemoMode?: boolean) =>
    ["coach-transcript-trends", coachId, isDemoMode] as const,
  coachPhaseDistributionRoot: () => ["coach-phase-distribution"] as const,
  coachPhaseDistribution: (coachId?: string, isDemoMode?: boolean) =>
    ["coach-phase-distribution", coachId, isDemoMode] as const,
  coachAttentionSignalsRoot: () => ["coach-attention-signals"] as const,
  coachAttentionSignals: (coachId?: string, isDemoMode?: boolean) =>
    ["coach-attention-signals", coachId, isDemoMode] as const,
  coachConversationsFullRoot: () => ["coach-conversations-full"] as const,
  coachConversationsFull: (coachId?: string) => ["coach-conversations-full", coachId] as const,
  unreadMessagesRoot: () => ["unread-messages"] as const,
  unreadMessages: (scope?: string) => ["unread-messages", scope] as const,
  coachAiLeadersRoot: () => ["coach-ai-leaders"] as const,
  coachAiLeaders: (coachId?: string) => ["coach-ai-leaders", coachId] as const,
  coachTranscriptAnalysesRoot: () => ["coach-transcript-analyses"] as const,
  coachTranscriptAnalyses: (coachId?: string) => ["coach-transcript-analyses", coachId] as const,
  coachReviewRoot: () => ["coach-review"] as const,
  coachReviewCountRoot: () => ["coach-review-count"] as const,
  coachReviewCount: (coachId?: string) => ["coach-review-count", coachId] as const,
  coachTranscriptFullRoot: () => ["coach-transcript-full"] as const,
  coachTranscriptFull: (transcriptId?: string) => ["coach-transcript-full", transcriptId] as const,
  coachTranscriptPracticeSummaryRoot: () => ["coach-transcript-practice-summary"] as const,
  coachTranscriptPracticeSummary: (leaderId?: string, meetingId?: string) =>
    ["coach-transcript-practice-summary", leaderId, meetingId] as const,
  practiceFocusCardRoot: () => ["practice-focus-card"] as const,
  practiceFocusCard: (leaderId?: string) => ["practice-focus-card", leaderId] as const,
  coachLensActiveRoot: () => ["coach-lens-active"] as const,
  coachLensActive: (coachId?: string) => ["coach-lens-active", coachId] as const,
  coachTwinActiveRoot: () => ["coach-twin-active"] as const,
  coachTwinActive: (coachId?: string) => ["coach-twin-active", coachId] as const,
  coachMemoryTranscriptContextRoot: () => ["coach-memory-transcript-context"] as const,
  coachMemoryTranscriptContextOwner: (coachId: string) => ["coach-memory-transcript-context", coachId] as const,
  coachMemoryTranscriptContext: (coachId?: string, leaderId?: string) =>
    ["coach-memory-transcript-context", coachId, leaderId] as const,
  proactiveMemoryLeader: (actorId?: string | null) =>
    ["proactive-memory", actorId, "leader", null] as const,
  proactiveMemoryCoach: (coachId?: string | null, leaderId?: string | null) =>
    ["proactive-memory", coachId, "coach", leaderId] as const,
  coachTranscriptMeetingRoot: () => ["coach-transcript-meeting"] as const,
  coachTranscriptMeeting: (meetingId?: string) => ["coach-transcript-meeting", meetingId] as const,
  coachTranscriptLeaderRoot: () => ["coach-transcript-leader"] as const,
  coachTranscriptLeader: (leaderId?: string) => ["coach-transcript-leader", leaderId] as const,
  coachSessionPrepV2Root: () => ["coach-session-prep-v2"] as const,
  coachSessionPrepV2Owner: (coachId: string) => ["coach-session-prep-v2", coachId] as const,
  coachSessionPrepV2: (coachId?: string, leaderId?: string) =>
    ["coach-session-prep-v2", coachId, leaderId] as const,
  coachSessionRecordsNeedsReviewRoot: () => ["coach-session-records-needs-review"] as const,
  coachSessionRecordsNeedsReview: (coachId?: string) =>
    ["coach-session-records-needs-review", coachId] as const,
  veeraSelectedMeetingContextRoot: () => ["veera-selected-meeting-context"] as const,
  veeraSelectedMeetingContext: (leaderId?: string) => ["veera-selected-meeting-context", leaderId] as const,
  veeraChatContextRoot: () => ["veera-chat-context"] as const,
  veeraChatContext: (leaderId?: string, transcriptId?: string | null, meetingId?: string | null) => {
    const key: ["veera-chat-context", ...(string | null | undefined)[]] =
      ["veera-chat-context", leaderId, transcriptId, meetingId];
    while (key.length > 1 && (key[key.length - 1] === undefined || key[key.length - 1] === null)) key.pop();
    return key;
  },
  transcriptAnalysisResult: (transcriptId?: string) => ["transcript-analysis-result", transcriptId] as const,
  coachSessionRecord: (transcriptId?: string) => ["coach-session-record", transcriptId] as const,
  transcriptEvidenceDetail: (transcriptId?: string) => ["transcript-evidence-detail", transcriptId] as const,
  reflectionDataForAnalysis: (transcriptId?: string) => ["reflection-data-for-analysis", transcriptId] as const,
} as const;
